import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const AppointmentBooking: React.FC<PropsType> = ({ size = 50, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <circle cx="21.6663" cy="15.8333" r="13.3333" fill="#FF878F" />
      <path
        d="M34.9606 20.7288C35.8868 18.2137 36.0805 15.4873 35.5192 12.8665C34.9579 10.2456 33.6646 7.83776 31.7895 5.92255C29.9144 4.00734 27.5345 2.66336 24.9261 2.04668C22.3177 1.43001 19.5879 1.56595 17.0537 2.43872C14.5195 3.31149 12.2848 4.88527 10.6093 6.97729C8.93376 9.06932 7.88608 11.5937 7.58793 14.2574C7.28978 16.9211 7.75338 19.6147 8.92491 22.0254C9.86625 23.9624 11.2336 25.653 12.9167 26.9748"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.878 17.6361C30.106 16.3543 30.0143 15.0361 29.6111 13.7982C29.2079 12.5603 28.5056 11.4409 27.5665 10.5393C26.6273 9.63764 25.4803 8.98152 24.227 8.62904C22.9737 8.27656 21.6529 8.23861 20.3814 8.51855C19.11 8.79848 17.9272 9.38766 16.9378 10.2339C15.9485 11.0801 15.1831 12.1573 14.7094 13.37C14.2358 14.5827 14.0686 15.8935 14.2225 17.1863C14.3765 18.479 14.8469 19.7139 15.5921 20.7814"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5498 15.8334C21.341 15.8334 20.361 16.8199 20.361 18.0368V33.4925C20.361 34.4653 19.1926 34.9525 18.5092 34.2646L16.9216 32.6665C15.9101 31.6483 14.2701 31.6483 13.2586 32.6665C12.2471 33.6847 12.2471 35.3356 13.2586 36.3538L20.9459 44.0923C21.0658 44.213 21.1946 44.3194 21.3301 44.4114C21.4307 44.4798 21.5255 44.5569 21.6074 44.6472C23.1709 46.3699 25.7962 47.5 28.7711 47.5C33.4363 47.5 37.2417 44.7207 37.4408 41.2356C37.4447 41.1678 37.4539 41.1002 37.4658 41.0333C37.4883 40.9067 37.5 40.7763 37.5 40.6432V28.8916C37.5 27.6746 36.52 26.6881 35.3111 26.6881C34.6399 26.6881 34.0392 26.9923 33.6377 27.4712C33.6377 26.2542 32.5142 25.2192 31.3053 25.2192C30.104 25.2192 29.1288 26.1934 29.1166 27.3997V25.9537C29.1166 24.7368 28.1366 23.7503 26.9277 23.7503C25.7188 23.7503 24.7388 24.7368 24.7388 25.9537L24.7387 18.0368C24.7387 16.8199 23.7587 15.8334 22.5498 15.8334Z"
        fill="white"
      />
      <path
        d="M33.6377 27.4712C34.0392 26.9923 34.6399 26.6881 35.3111 26.6881C36.52 26.6881 37.5 27.6746 37.5 28.8916V40.6432C37.5 40.7763 37.4883 40.9067 37.4658 41.0333C37.4539 41.1002 37.4447 41.1678 37.4408 41.2356C37.2417 44.7207 33.4363 47.5 28.7711 47.5C25.7962 47.5 23.1709 46.3699 21.6074 44.6472C21.5255 44.5569 21.4307 44.4798 21.3301 44.4114C21.1946 44.3194 21.0658 44.213 20.9459 44.0923L13.2586 36.3538C12.2471 35.3356 12.2471 33.6847 13.2586 32.6665C14.2701 31.6483 15.9101 31.6483 16.9216 32.6665L18.5092 34.2646C19.1926 34.9525 20.361 34.4653 20.361 33.4925V18.0368C20.361 16.8199 21.341 15.8334 22.5498 15.8334C23.7587 15.8334 24.7387 16.8199 24.7387 18.0368L24.7388 25.9537M33.6377 27.4712C33.6377 26.2542 32.5142 25.2192 31.3053 25.2192C30.104 25.2192 29.1288 26.1934 29.1166 27.3997M33.6377 27.4712V32.234M29.1166 27.3997V25.9537C29.1166 24.7368 28.1366 23.7503 26.9277 23.7503C25.7188 23.7503 24.7388 24.7368 24.7388 25.9537M29.1166 27.3997V30.5961M24.7388 25.9537V28.9581"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AppointmentBooking;
